import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { getSitesByDomain, signUp } from "../../AsianExchangeSrc/api";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../AsianExchangeSrc/redux/slices/userSlice";
import { setAccountType } from "../../AsianExchangeSrc/redux/slices/accountSlice";
import { toast } from "react-toastify";
import Loading from "../../SkyExchangeSrc/src/components/Loading";
import { newSky } from "../../AsianExchangeSrc/utils/helper/commonSelectors";

const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFetchingSite, setIsFetchingSite] = useState(true);
  const [params, setParams] = useState({});
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState("");

  const SkyDesign = useSelector(newSky());

  const [formData, setFormData] = useState({
    mobile: "",
    otp: "",
    userName: "",
    name: "",
    password: "",
    confirmPassword: "",
    x_panel_type: "user",
    commission: 0,
    openingBalance: 0,
    availableBalance: 0,
    creditReference: 0,
    partnership: 0,
    currency: "INR",
    exposureLimit: 0,
    exposure: 0,
    createdBy: "",
    deviceIp: "0.0.0",
    role: "",
    domain: "",
    ownerDomainId: "",
    referralKey: "",
    isFirstLogin: false,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const refValue = queryParams.get("reffrel") || queryParams.get("referral");
    if (refValue) {
      setParams({ reffrel: refValue });
    }
  }, []);

  const generateOtp = () => {
    const randomNum = Math.floor(1000 + Math.random() * 9000);
    setGeneratedOtp(randomNum.toString());
  };

  useEffect(() => {
    generateOtp();
  }, []);

  useEffect(() => {
    const fetchSiteDetails = async () => {
      try {
        setIsFetchingSite(true);
        const domainName = window.location.host;
        const response = await getSitesByDomain(domainName);
        const siteDetails = response?.data;
        setUserData(siteDetails);
      } catch (error) {
        console.error("Failed to fetch site details:", error);
        toast.error("Failed to load site details");
      } finally {
        setIsFetchingSite(false);
      }
    };

    fetchSiteDetails();
  }, []);

  useEffect(() => {
    if (userData) {
      setFormData((prev) => ({
        ...prev,
        createdBy: params.reffrel
          ? ""
          : userData?.createdBy?._id || userData.siteDetails.createrId || "",
        role: userData?.userRoleId || "",
        domain: userData?.siteDetails?.domainDetails?._id || "",
        ownerDomainId: userData?.siteDetails?.admindomainName?._id || "",
        ...(params.reffrel && { referralKey: params.reffrel }),
      }));
    }
  }, [userData, params]);

  const validatePassword = (password) => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@]{6,}$/;
    const hasInvalidSpecialChar = /[^A-Za-z\d@]/.test(password);

    if (!strongPasswordRegex.test(password) || hasInvalidSpecialChar) {
      setPasswordError(
        "Use 6+ chars: uppercase, lowercase, number, '@' optional."
      );
    } else {
      setPasswordError("");
    }
  };

  const handleRegister = async (e) => {
    e?.preventDefault();
    if (passwordError) {
      toast.error("Enter a strong password!");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    try {
      setIsLoading(true);
      const trimmedFormData = {
        ...formData,
        mobile: formData.mobile.trim(),
        userName: formData.userName.trim(),
        password: formData.password.trim(),
      };

      const response = await signUp(trimmedFormData);

      if (response.data) {
        const { token, userdata } = response.data;

        dispatch(
          loginSuccess({
            userData: userdata,
            loggedInType: "real",
            token: token,
          })
        );

        dispatch(
          setAccountType({
            userData: userdata,
            type: "real",
          })
        );

        if (response.success) {
          toast.success("Registration Successful!");
          setTimeout(() => {
            navigate("/login");
          }, 1000);
        } else {
          setError(response.data.message);
          toast.error(response.data.message);
          generateOtp();
        }
      }
    } catch (error) {
      setError("Registration failed. Please try again.");
      toast.error("Registration failed. Please try again.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(SkyDesign === "true" && name === "userName" && { name: value }),
    }));
  };

  return (
    <div className="Sign-up">
      {(isFetchingSite || isLoading) && <Loading />}

      <div
        className={`login-container ${
          SkyDesign === "true" ? "login-container-fornewfooter" : ""
        }`}
      >
        <div className="login-head">
          <Link to="/">
            <div className="login-close">
              <IoMdClose />
            </div>
          </Link>
        </div>

        <form onSubmit={handleRegister}>
          <div className="auth-login-from">
            <h1 className={SkyDesign === "true" ? "text-white" : ""}>
              Register as New User
            </h1>

            <div className="auth-login-input">
              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={(e) => {
                  const value = e?.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                maxLength={10}
                disabled={isLoading}
              />
            </div>

            {SkyDesign !== "true" && (
              <div className="auth-login-input">
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isLoading}
                />
              </div>
            )}

            <div className="auth-login-input">
              <input
                type="text"
                name="userName"
                placeholder="Username"
                value={formData.userName}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            <div className="auth-login-input">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={(e) => {
                  handleChange(e);
                  validatePassword(e?.target.value);
                }}
                disabled={isLoading}
              />
            </div>

            {passwordError && (
              <p className="mb-2" style={{ color: "red", fontSize: "13px" }}>
                {passwordError}
              </p>
            )}

            <div className="auth-login-input">
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            <div className="auth-login-input">
              <input
                type="text"
                name="referralKey"
                placeholder="Referral Code Optional"
                value={formData.referralKey}
                onChange={handleChange}
                disabled={isLoading}
              />
            </div>

            {error && (
              <p
                style={{
                  fontSize: "13px",
                  color: "red",
                  marginTop: "-8px",
                  marginBottom: "5px",
                }}
              >
                {error}
              </p>
            )}

            <p className="sign-agree">
              By clicking on the Register button, you agree to the Terms and
              Conditions and confirm that you are over 18 years old.
            </p>

            <button type="submit" disabled={isLoading || isFetchingSite}>
              {isLoading ? "Registering..." : "Register"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
